<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        :text= "this.$t('datadownload')"
        icon="arrow-alt-circle-down"
        color="bg-green-400"
      />
    </l-container>

    <div v-show="true" class="w-full flex flex-col">
      <div class="pl-5 pt-5 pb-5 grid md:grid-cols-8 gap-1 bg-white" >
        <div class="md:col-span-3" >
          <l-ToolTip style="width: 100%" :text="$t('dateChooserTooltip')" direction="right">
            <vue-ctk-date-time-picker v-model="dateRange" id="daterange" :no-value-to-custom-elem="true" input-size="lg" format="YYYY-MM-DD" formatted="DD-MM-YYYY" :label="$t('choosedates')" button-now-translation="Nå" color="#7fa99b" :no-clear-button="true" :no-header="true" :range="true" :custom-shortcuts="customDateShortcuts" :max-date="maxDate"></vue-ctk-date-time-picker>
          </l-ToolTip> 
        </div>
        <div class="d-flex ml-100">
          <vue-ctk-date-time-picker v-model="startHour" id="starthour" :no-value-to-custom-elem="true" input-size="lg" format="HH:mm" formatted="HH:mm" :label="$t('starthour')" button-now-translation="Nå" color="#7fa99b" :no-clear-button="true" :no-header="true" :onlyTime="true"></vue-ctk-date-time-picker>
        </div>
        <div class="d-flex">
          <vue-ctk-date-time-picker v-model="endHour" id="endhour" :no-value-to-custom-elem="true" input-size="lg" format="HH:mm" formatted="HH:mm" :label="$t('endhour')" button-now-translation="Nå" color="#7fa99b" :no-clear-button="true" :no-header="true" :onlyTime="true"></vue-ctk-date-time-picker>
        </div>
        <div v-show="!dataexists" class="mt-5 md:col-start-1 md:col-span-4 text-red-700 text-lg">
          {{$t('nodataexists')}}
        </div>
        <div class="mt-5 md:col-start-1 md:col-span-3">
          <l-select2 style="width: 100%; color: #000000" v-model="selectedSensor" :multiple="true" :options="computedSensors" :placeholder="$t('selectsensorunit')" />        
        </div>
        <div class= "mt-5 md:col-span-2">
          <l-select2 style="width: 100%; color: #7fa99b" v-model="selectedComponents" :multiple="true" :options="computedComponents" :placeholder="$t('selectcomponent')" />
        </div>
      </div>
      <div>
        <div class="mt-5 ml-5 md:col-start-1 md:col-span-4">
          <b>{{$t('origHeader')}} </b><br>
          <label>{{$t('origText1')}} </label><br>
          <label>{{$t('origText2')}} </label>    
        </div>
        <!--
        <div class="mt-5 ml-5 md:col-start-1 md:col-span-3">
          <l-select2 style="width: 100%; color: #7fa99b" v-model="selectedSensor" :multiple="true" :options="computedSensors" :placeholder="$t('selectsensorunit')" />        
        </div>
        <div class= "mt-5 md:col-span-2">
          <l-select2 style="width: 100%; color: #7fa99b" v-model="selectedComponents" :multiple="true" :options="computedComponents" :placeholder="$t('selectcomponent')" />
        </div>
      -->
        <div class="md:col-start-1 md:col-span-8">
          <div class="inline-block">
            <LToogleButton class="ml-5 mr-5 mt-3"  :firstactive="semicolon" :label1="$t('semicolon')" :label2="$t('comma')"></LToogleButton>
          </div>
          <l-button class="inline-block" type="success" :disabled="!isComplete" @click="downloadascsv">
            <font-awesome-icon icon="arrow-circle-down" class="text-black mr-2"/>{{$t('downloadcsv')}}
          </l-button>
      </div>
      </div>
      <div class="mt-5 grid md:grid-cols-8 gap-1 bg-gray-100 ">
        <div class="mt-5 ml-5 md:col-start-1 md:col-span-4">
          <b>{{$t('aggHeader')}} </b><br>
          <label>{{$t('aggText1')}} </label><br>
          <label>{{$t('aggText2')}}  </label>    
        </div>
        <!--
        <div class="mt-5 ml-5 md:col-start-1 md:col-span-4">
            <l-select2 style="width: 100%; color: #7fa99b" v-model="selectedSensorComponents" :multiple="true" :options="computedSensorsComponents" :placeholder="$t('selectsenscomp')" />        
        </div>
      -->
      
        <div class="ml-5 md:col-start-1 md:col-span-4">
          <l-select2 style="width: 100%; color: #7fa99b" v-model="selectedAggregation" :multiple="false" :options="aggregations" :placeholder="$t('selectAggregations')" />        
        </div>
          <div class="ml-5 mb-5 mt-3 md:col-start-1 md:col-span-8">
            <l-button class="inline-block" type="success" :disabled="!isAggComplete" @click="showingraph">
              <font-awesome-icon icon="chart-line" class="text-black mr-2"/>{{$t('showingraph')}}
            </l-button>
            <label class="ml-5 font-bold">{{$t('csvMissingdatalbl')}} </label> 
            <l-button class="ml-5 inline-block" type="success" :disabled="!isAggComplete" @click="downloadascsvwithmissing">
              <font-awesome-icon icon="arrow-circle-down" class="text-black mr-2"/>{{$t('downloadcsvwithmissing')}}
            </l-button>
        </div>
        
      </div>

      <div class="mt-5 grid md:grid-cols-8 gap-1">
        
      </div>
    </div>
    <div v-show="graphshow">
      <highcharts width="100%" height="500px" class="chart" :options="chartOptions" ref="lineCharts"></highcharts> 
    </div>

  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import Notify from "@/helpers/notify";
import LToolTip from "@/components/forms/popper/LToolTip";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import * as moment from "moment";
import SensorsService from "@/helpers/apiservices/sensors/sensors.service";
import ObservationsService from "@/helpers/apiservices/observations/observations.service";
import LSelect2 from "@/components/forms/select/LSelect2";
import LToogleButton from "@/components/forms/button/LToogleButton";
import { LButton } from "@/components/forms";

export default {
  name: "datadownload",
  components: {
    LToolTip, 
    VueCtkDateTimePicker,
    LSelect2,
    LToogleButton,
    LButton 
  },
  data() {
    return {
      sensors: [],
      selectedSensor: [],
      selectedComponents: [],
      selectedSensorComponents: [],
      selectedAggregation: null,
      aggregations: [
        { label: this.$t('alHour') , value: 'hourly', isSelected: true },
        { label: this.$t('alDay') , value: 'daily', isSelected: false },
        { label: this.$t('alWeek') , value: 'weekly', isSelected: false },
        { label: this.$t('alMonth') , value: 'monthly', isSelected: false },
      ],
      aggregatedObservations: [],
      dateRange: {},
      semicolon: true,
      customDateShortcuts: [
        { key: "last14days", label: this.$t('last14days') , value: 14, isSelected: true },
        { key: "today", label: this.$t('today'), value: 1, isSelected: false },
        { key: "thisweek", label: this.$t('thisweek'), value: "isoWeek", isSelected: false },
        { key: "lastweek", label: this.$t('lastweek'), value: "-isoWeek", isSelected: false },
        { key: "thismonth", label: this.$t('thismonth'), value: "month", isSelected: false },
        { key: "lastmonth", label: this.$t('lastmonth'), value: "-month", isSelected: false },
      ],
      startHour: "00:00",
      endHour: "00:00",
      graphshow: false,
      dataexists : true,
      chartOptions: {
        chart: {
            type: 'line',
            boostThreshold: 1,
            turboThreshold: 0,
            animation: true,
        },
        plotOptions: {
          series: {
            marker: {
              enabled: true
            }
          }
        },
        xAxis: {
          type: 'datetime', 
          labels: {
            rotation: -45,
            formatter: function () {                
                //return moment(new Date(0).setUTCMilliseconds(this.value)).format('DD/MM/YY HH:mm');
                return moment(this.value).format('DD/MM/YY HH:mm');
            },
            style:{
                fontSize: "8px"
            }
          }
        },
        yAxis: {
          allowDecimals: true,
          labels: {
            formatter: function () {                
                return this.value;
            }
          }
        },
        tooltip: {
          formatter: function() {
            return  '<b>' + this.series.name + '  ' + this.y + '</b><br/>' + moment(this.x).format('DD/MM/YYYY HH:mm');
            //return moment(this.x).format('DD/MM/YY HH:mm');
          }
        }, 
        series: [],
        exporting: {
          enabled: true,
          csv: {
              itemDelimiter: ';'
          },
        }
      }
    };
  },
  mounted() {
    let url = new URL(window.location.href);
    this.dateRange =  { start: moment().subtract(24,"hours"), end: moment()};
    this.loadInitialData();
    //Notify.loadData(null, this.loadInitialData);
  },

  methods: {
    async loadInitialData() {
      this.sensors = await SensorsService.sensors();
      this.selectedSensor = [];
    },
    async downloadascsv(){
        this.dataexists = true;
        const comps = [];
        this.selectedComponents.forEach((c) => {
            comps.push(c.label);
        });
      let filtering;
      const filteringArr = [];
      
      for(let i = 0; i < this.selectedSensor.length ; i++){
        filtering = {
            From: moment(moment(this.dateRange.start).utc().format('YYYY-MM-DD') + " " + this.startHour).unix(),
            To: moment(moment(this.dateRange.end).utc().format('YYYY-MM-DD') + " " + this.endHour).unix(),
            SensorId: this.selectedSensor[i].value,
            ProviderId: this.selectedSensor[i].providerid,
            Components: comps,
            Delimiter: this.semicolon ? ";" : ","
          };
          filteringArr.push(filtering);
      }
      
      this.dataexists = await ObservationsService.sensorobservationsCsvArray(filteringArr);

    },
    async downloadascsvwithmissing(){
        this.dataexists = true;
        const comps = [];
        this.selectedComponents.forEach((c) => {
            comps.push(c.label);
        });
       
      let filtering;
      const filteringArr = [];
      
      for(let i = 0; i < this.selectedSensor.length ; i++){
        filtering = {
            From: moment(moment(this.dateRange.start).utc().format('YYYY-MM-DD') + " " + this.startHour).unix(),
            To: moment(moment(this.dateRange.end).utc().format('YYYY-MM-DD') + " " + this.endHour).unix(),
            SensorId: this.selectedSensor[i].value,
            ProviderId: this.selectedSensor[i].providerid,
            Components: comps,
            AggLevel: this.selectedAggregation.value ,
            Delimiter: this.semicolon ? ";" : ","
          };
          filteringArr.push(filtering);
      }
      
      if(filteringArr[0].AggLevel == "weekly"){
        filteringArr.forEach((f) => {
          var utcSeconds = f.From;
          var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
          d.setUTCSeconds(utcSeconds);
          var curr = new Date(d);
          var first = curr.getDate() - curr.getDay() + 1; // First day is the day of the month - the day of the week
          f.From = Date.parse(new Date(curr.setDate(first)).toUTCString())/1000;
        });

      }
      else if(filteringArr[0].AggLevel == "monthly"){
        filteringArr.forEach((f) => {
          var utcSeconds = f.From;
          var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
          d.setUTCSeconds(utcSeconds);
          var curr = new Date(d);
          var firstDay = new Date(curr.getFullYear(), curr.getMonth(), 1 , 12);
          f.From = Date.parse(firstDay)/1000;
        });

      }
  
      this.dataexists = await ObservationsService.sensorobservationsCsvArrayWithMissingAgg(filteringArr);

    },
     async showingraph(){
       this.dataexists = true;
       this.graphshow = true;
       this.$refs.lineCharts.chart.setTitle({text: this.$t('aggGhraphTitleWait')});

       //clear series and graph
      var series_ids = [];
      for (var s in this.$refs.lineCharts.chart.series) {
          series_ids.push(this.$refs.lineCharts.chart.series[s].options.id);
      }
      for (var id in series_ids) {
          this.$refs.lineCharts.chart.get(series_ids[id]).remove(true);
      }

      const sensorscomp = [];
      this.selectedSensor.forEach((s) => {
        this.selectedComponents.forEach((c) => {
          sensorscomp.push({"SensorId" : s.value, "SensorName": s.label, "Component": c.label, "ProviderId": s.providerid});
        });
       
     });

//      this.selectedSensorComponents.forEach((c) => {
//        sensorscomp.push({"SensorId" : c.sensorid, "SensorName": c.sensorname, "Component": c.component, "ProviderId": c.providerid});
//      });

      const filtering = {
        From: moment(moment(this.dateRange.start).utc().format('YYYY-MM-DD') + " " + this.startHour).unix(),
        To: moment(moment(this.dateRange.end).utc().format('YYYY-MM-DD') + " " + this.endHour).unix(),
        ProviderId: this.selectedSensor.providerid,
        AggLevel: this.selectedAggregation.value,
        Sensors: sensorscomp
      };

      this.aggregatedObservations = await ObservationsService.aggregeatedobservations(filtering);

      if(this.aggregatedObservations.length < 0 || this.aggregatedObservations[0].AggObservations.length < 1){
        this.dataexists = false;
      }
      else if(this.aggregatedObservations.length === 1 && this.aggregatedObservations[0].AggObservations.length < 1){
        this.dataexists = false;
      }
      
      this.aggregatedObservations.forEach(ao => {
        let d = [];
        for(var m = 0; m < ao.AggObservations.length; m++){
            if(ao.AggObservations[m].value != -9900){
                //d.push([moment.unix(m.timestamp_to_epoch), m.value])
                d.push([ao.AggObservations[m].timestamp_to_epoch * 1000, ao.AggObservations[m].avg])

            }
        }
        //
        var Aggunit;
        if(filtering.AggLevel == "hourly"){
          Aggunit = 3600*1000;
        }
        else if(filtering.AggLevel == "daily"){
          Aggunit = 3600*24*1000;
        }
        else if(filtering.AggLevel == "weekly"){
          Aggunit = 3600*24*7*1000;
        }
        //
        if(d.length>0){
            d.sort(function(a,b){
                return a[0] - b[0];
            });
            var d1 = d;
            let tmp = [];
            let Arr2= [];
            let counter = -1;
            for(let j = 0 ; j < d1.length - 1 ; j++){
              if(j == 0){
                Arr2.push([...d1[j]]);
                counter = counter +1;
              }
              else if(j > 0 && d1[j] !== undefined ){
                let var1 = d1[j][0];
                let var2 = Arr2[counter][0];

                if(var1 - var2 > Aggunit){

                tmp.push([...Arr2[counter]]);
                tmp[0][0] = tmp[0][0] + Aggunit; //insert row data for next hour
                tmp[0][1] = null; //insert null value
                Arr2.push([...tmp[0]]);
                tmp.pop();
                counter = counter + 1; 
                j = j-1;
                continue;
                }
                else{
                Arr2.push(d1[j]);
                counter = counter + 1;

                }
              }
              
            }
            d1 = Arr2;
            var parsedData = [], zonesX = [];
            var mytime,myvalue
            d1.forEach(function(value, i) {
              mytime = value[0];
              myvalue = value[1];
            if (myvalue !== null) {
              parsedData.push([
              mytime, myvalue
              ]);

              zonesX.push({
                value: mytime
              });
            } else {
              zonesX.push({
                dashStyle: 'dot',
                value: mytime + Aggunit
              });
            }
          });

            //mseries.push({name : unique[u], data: d });
            //this.$refs.lineCharts.chart.addSeries({id: ao.name + "_" + ao.component, name: ao.name + "_" + ao.component, data: d}); 
            this.$refs.lineCharts.chart.addSeries({id: ao.name + "_" + ao.component, name: ao.name + "_" + ao.component, zoneAxis: 'x',zones: zonesX, data: parsedData});
          }
      });

      this.$refs.lineCharts.chart.setTitle({text: this.$t('aggHeader')});


    },
  },
  computed: {
      computedComponents() {
        let senscomps = [];
        if((this.selectedSensor).length > 0){
          this.selectedSensor.forEach(sensor => {
            sensor.components.map(comp=>{
              senscomps.push({"label": comp.name, "value": comp.id});
            });  
          });
          senscomps = senscomps.filter((value, index, self) =>
            index === self.findIndex((t) => (
              t.label === value.label && t.value === value.value
            ))
          );
          senscomps = [...new Set(senscomps)];
        }
        else{
          senscomps = [];
        }
        return senscomps;
      },
      computedSensors() {
        if(this.sensors.length > 0){
          return this.sensors.map(sensor => {return {label: sensor.name, value: sensor.id, components: sensor.components, providerid: sensor.provider.id}});
        }
        return [];
      },
      computedSensorsComponents(){
        let senscomps = [];
        if(this.sensors.length > 0){
          this.sensors.forEach(sensor => {
            sensor.components.forEach(c=>{
              senscomps.push({label: `${sensor.name}, ${sensor.description.substr(0,15)}..., ${c.name}, Level ${c.level.value}`, 
                              providerid: sensor.provider.id,
                              sensorid: sensor.id,
                              sensorname: sensor.name,
                              component: c.name});
            });  
          });
        }
        return senscomps;
      },
      isComplete(){
        return this.selectedComponents.length > 0 && this.selectedSensor;   
      },
      isAggComplete(){
        //return this.selectedSensorComponents.length > 0 && this.selectedAggregation;
        return this.selectedSensor.length > 0 && this.selectedComponents.length > 0 && this.selectedAggregation;

      },
      maxDate() {
        const max = moment(this.dateRange.start).add(2, 'month');
        return max.format('YYYY-MM-DDTHH:mm:ss');
      }, 
  },
};
</script>



